export const LOCALE_BY_LANG = {
  en: 'en-US',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  ja: 'ja-JP',
  ko: 'ko-KR',
  'zh-CN': 'zh-CN',
  'pt-BR': 'pt-BR',
  ru: 'ru-RU',
  hi: 'hi-IN',
  ar: 'ar',
  id: 'id-ID',
};

export const resolveLocale = (lang) => LOCALE_BY_LANG[lang] || lang || 'en-US';

export const formatLocalizedNumber = (value, lang = 'en', { fractionDigits } = {}) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    if (fractionDigits === undefined) return '0';
    return fractionDigits > 0 ? '0.00' : '0';
  }

  const localeOptions = fractionDigits === undefined
    ? {}
    : {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    };

  return numericValue.toLocaleString(resolveLocale(lang), localeOptions);
};
